/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Input,
  ModalFooter,
} from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';
import axios from 'axios';
import { api } from '../../config';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import notify, { MESSAGES } from '../../utils/notify';
import '../TenderOpening/components/TenderOpening.css';
import './ProcurementView.css';
import metaMask from '../../assets/images/nft/newrecord.png';
import Select from 'react-select';
import ProductHydro from './component/ProductHydro';
import ActionButton from '../../Components/Common/ActionButton';
import useProcurementInsights from './hooks/useProcurementInsights';
import { HeroInsights } from './component/ListBadges';
import { QUICK_FILTERS } from './utils/procurementList';

// This page lists Product Hydro procurements only (ProcurementTypeHeader = 1).
const PROCUREMENT_TYPE_HEADER = '1';

const ProcurementList = () => {
  const navigate = useNavigate();
  const token = getAuthToken();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [quickFilter, setQuickFilter] = useState('');

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const insights = useProcurementInsights({
    procurementTypeHeader: PROCUREMENT_TYPE_HEADER,
    refreshTrigger,
  });
  // Authentication validation
  useEffect(() => {
    if (!token) {
      notify.error(MESSAGES.authRequired);
      return;
    }
    if (!isAuthenticated()) {
      notify.error(MESSAGES.authRequired);
      return;
    }
  }, [token]);

  const [modal, setModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    titleProcurement: '',
    procurementType: '',
    description: '',
    procurementTypeHeader: '',
  });

  const procurementtype = [
    {
      options: [
        { label: 'Pelelangan Khusus', value: 'PelelanganKhusus' },
        { label: 'Pemilihan Langsung', value: 'PemilihanLangsung' },
        { label: 'Tunjuk Langsung', value: 'TunjukLangsung' },
      ],
    },
  ];

  const handleprocurementTypeChange = selectedOption => {
    setFormData({ ...formData, procurementType: selectedOption.value });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateFields = () => {
    let tempErrors = {};
    if (!formData.titleProcurement) {
      tempErrors.titleProcurement = 'Please Enter Title';
    }

    if (!formData.procurementTypeHeader) {
      tempErrors.procurementTypeHeader = 'Please Select Procurement Type';
    }
    if (!formData.procurementType) {
      tempErrors.procurementType = 'Please Select ';
    }
    if (!formData.description) {
      tempErrors.description = 'Please Enter Description';
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const closeModal = () => {
    setFormData({
      titleProcurement: '',
      procurementType: '',
      description: '',
      procurementTypeHeader: '',
    });
    setErrors({});
    setModal(!modal);
  };

  const handleSubmit = async e => {
    if (validateFields()) {
      e.preventDefault();
      try {
        const response = await axios.post(
          `${api.API_URL}/procurement`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.id) {
          notify.success(MESSAGES.saved);
          navigate(`/apps-procurement/upd/${response.id}`);
        } else {
          notify.error('Failed to save data. Please try again.');
        }
      } catch (error) {
        notify.apiError(error, 'save data');
      }
    }
  };

  const togglemodal = useCallback(() => {
    setFormData({
      titleProcurement: '',
      procurementType: '',
      description: '',
      procurementTypeHeader: PROCUREMENT_TYPE_HEADER,
    });
    setModal(prev => !prev);
  }, []);

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb
                fallback={{
                  label: 'Plan & Procurement',
                  to: '/apps-procurement/view',
                }}
              />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-file-list-3-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>Planning & Procurement</h4>
                  <p className='to-hero-subtitle'>
                    Prepare requirements, supporting documents and supplier
                    invitations before submitting to tender opening.
                  </p>
                </div>
                <div className='d-flex gap-2 flex-wrap'>
                  <button
                    type='button'
                    className='to-hero-btn'
                    onClick={handleRefresh}
                  >
                    <i className='ri-refresh-line' aria-hidden='true' />
                    Refresh
                  </button>
                  <button
                    type='button'
                    className='to-hero-btn to-hero-btn--solid'
                    onClick={togglemodal}
                  >
                    <i className='ri-add-line' aria-hidden='true' />
                    Create New
                  </button>
                </div>
              </div>

              <HeroInsights
                insights={insights}
                filters={QUICK_FILTERS}
                activeKey={quickFilter}
                onChange={setQuickFilter}
                noun='draft'
                emptyLabel='All drafts on track'
              />
            </div>

            <ProductHydro
              refreshTrigger={refreshTrigger}
              quickFilter={quickFilter}
              onQuickFilterChange={setQuickFilter}
              onDataChanged={handleRefresh}
              onCreate={togglemodal}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>

      <Modal
        size='lg'
        isOpen={modal}
        role='dialog'
        autoFocus={true}
        centered
        id='addAddressModal'
        toggle={togglemodal}
        data-bs-backdrop='static'
        className='modal-fullscreen-sm-down'
      >
        <ModalHeader
          className='bg-soft-info p-3'
          toggle={() => {
            setModal(!modal);
          }}
        ></ModalHeader>

        <ModalBody>
          <div className='d-flex mt-1'>
            <Col xxl={12}>
              <div>
                <Row className='justify-content-center mb-1'>
                  <Col lg={12} className='text-center'>
                    <img
                      src={metaMask}
                      alt=''
                      height='65'
                      className='mb-2 pb-2'
                    />
                    <h5>Create New Planning & Procurement </h5>
                    <p className='text-muted pb-1'>
                      Start a new procurement request by filling in the details
                      below.
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className='mb-2 bor border-top  border-top-dashed '></div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={6}>
                    <div className='mb-1'>
                      <Label htmlFor='titleProcurement' className='form-label'>
                        Title Procurement
                      </Label>
                      <Input
                        type='text'
                        className='form-control '
                        id='titleProcurement'
                        name='titleProcurement'
                        placeholder='Enter Title Procurement'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            titleProcurement: '',
                          });
                        }}
                      />
                    </div>
                    {errors.titleProcurement && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='ri-error-warning-line'></i>
                        <span>{errors.titleProcurement}</span>
                      </div>
                    )}{' '}
                  </Col>
                  <Col sm={12} md={6}>
                    <div className='mb-1'>
                      <span
                        htmlFor='choices-publish-status-input'
                        className='form-label'
                      >
                        Proc Type{' '}
                      </span>

                      <Select
                        name='procurementType'
                        id='procurementType'
                        placeholder='-- Please Select --'
                        options={procurementtype}
                        onChange={e => {
                          handleprocurementTypeChange(e);
                          setErrors({
                            ...errors,
                            procurementType: '',
                          });
                        }}
                      />
                    </div>
                    {errors.procurementType && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='ri-error-warning-line'></i>
                        <span>{errors.procurementType}</span>
                      </div>
                    )}{' '}
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <div>
                      <Label
                        htmlFor='exampleFormControlTextarea5'
                        className='form-label'
                      >
                        Description{' '}
                      </Label>
                      <textarea
                        className='form-control'
                        id='description'
                        name='description'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            description: '',
                          });
                        }}
                        rows='5'
                      ></textarea>
                    </div>
                    {errors.description && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='ri-error-warning-line'></i>
                        <span>{errors.description}</span>
                      </div>
                    )}{' '}
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className='hstack gap-2 justify-content-end d-print-none mt-4 flex-wrap'>
            <ActionButton
              variant='secondary'
              icon='ri-close-line'
              className='flex-fill flex-sm-grow-0'
              onClick={closeModal}
            >
              Close
            </ActionButton>
            <ActionButton
              variant='primary'
              type='submit'
              className='ms-auto flex-fill flex-sm-grow-0'
              onClick={handleSubmit}
            >
              Next
              <i
                className='ri-arrow-right-line align-middle ms-2'
                aria-hidden='true'
              ></i>
            </ActionButton>
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default React.memo(ProcurementList);
